import { render, staticRenderFns } from "./LeftRight.vue?vue&type=template&id=36d5a27f&"
import script from "./LeftRight.vue?vue&type=script&lang=js&"
export * from "./LeftRight.vue?vue&type=script&lang=js&"
import style0 from "./LeftRight.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports